"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const luxon_1 = require("luxon");
const utils_1 = require("./utils");
const index_1 = require("../index");
const TimeZoneRow_1 = require("./TimeZoneRow");
class PredicateListDatePageValueIndexSelector extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps) {
        if (this.props.values.length > prevProps.values.length) {
            const body = document.getElementById('predicate-builder-body');
            body.scrollTop = body.offsetHeight;
        }
    }
    render() {
        const { values, ordered, updatePageValueIndexSelected, device, minArrLength, handleValueUpdate } = this.props;
        const { Fragment } = React;
        return (React.createElement(Fragment, null,
            values.map((value, index) => (React.createElement("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => updatePageValueIndexSelected('dateOverview', index), key: index },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement("div", { style: {
                            marginLeft: 8,
                            marginRight: 8,
                        } }, ordered ? (React.createElement(index_1.Badge, { color: index_1.charcoal, text: `${index + 1}.` })) : (React.createElement("div", { style: {
                            background: index_1.charcoal,
                            height: 6,
                            width: 6,
                            borderRadius: 3,
                        } }))),
                    React.createElement(index_1.Text, { text: utils_1.getDisplayDate(value), size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                            marginRight: 42,
                        } }),
                    React.createElement(index_1.Text, { text: utils_1.getDisplayTime(value), size: device === 'Mobile' ? 'large' : 'medium' })),
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    values.length !== minArrLength && (React.createElement("div", { style: {
                            height: 24,
                            marginRight: 8,
                        } },
                        React.createElement(index_1.CircleCloseIcon, { fill: index_1.aquamarine, onClick: (e) => {
                                e.stopPropagation();
                                handleValueUpdate([...values.slice(0, index), ...values.slice(index + 1)]);
                            } }))),
                    React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver }))))),
            React.createElement(index_1.PlusSquareIcon, { onClick: () => {
                    handleValueUpdate(values.concat(luxon_1.DateTime.fromISO(values[values.length - 1], {
                        setZone: true,
                    })
                        .plus({ hours: 1 })
                        .toISO()));
                }, fill: index_1.turquoise, style: {
                    marginTop: 16,
                    marginBottom: 8,
                } }),
            React.createElement(TimeZoneRow_1.default, { device: device, value: values[0], onClick: () => updatePageValueIndexSelected('selectTimeZone', 0) })));
    }
}
PredicateListDatePageValueIndexSelector.defaultProps = {
    minArrLength: 1,
};
exports.default = PredicateListDatePageValueIndexSelector;
